<template>
  <div class="d-flex align-center justify-center text-center flex-wrap">
    <v-card-title class="justify-center" style="width: 100%;">Выберите вид кредита</v-card-title>
    <div
        v-for="item in paymentTypes"
        :key="item.type"
        class="pa-5">
      <v-card :disabled="disabled" :color="value === item.type ? 'primary': null" :dark="value === item.type" width="300" v-ripple class="cursor-pointer"
              @click="selectPaymentType(item.type)">
        <v-card-title class="pb-0 justify-center">{{ item.title }}</v-card-title>
        <v-card-text class="pa-5">
          <v-icon color="#EBEFF2" size="150">{{ item.icon }}</v-icon>
        </v-card-text>
      </v-card>
    </div>
    <div style="width: 100%" class="d-flex justify-center">
      <v-sheet
          v-if="!hasAvailableWorkers"
          rounded
          width="650"
          class="px-2 py-1"
          color="warning"
      >Чтобы создать кредит вы с начало должны создать сотрудника для этого филиала. Для этого перейдите в раздел <router-link :to="{name: 'workers-index'}">"Сотрудники"</router-link>
      </v-sheet>
    </div>
  </div>
</template>

<script>
import {CREDIT_PAYMENT_TYPES} from "@/utils/constants"
const CREDIT_PAYMENT_TYPES_INDEX = CREDIT_PAYMENT_TYPES.reduce((initial, item) => {
  initial[item.value] = item.value
  return initial
}, {})


export default {
  name: 'CreditStartStep',
  props: {
    hasAvailableWorkers:{
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: true
    },
    value: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      paymentTypes: [
        {
          title: 'С картой',
          icon: 'fas fa-credit-card',
          type: CREDIT_PAYMENT_TYPES_INDEX.card
        },
        {
          title: 'Без карты',
          icon: 'fas fa-wallet',
          type: CREDIT_PAYMENT_TYPES_INDEX.cash
        },
      ]
    }
  },
  methods: {
    selectPaymentType(type) {
      this.$emit('input', type)
      this.$emit('apply')
    }
  },
}
</script>
